import { css } from '@emotion/react';

import { borderRadius } from '@/styles/radius';

/**
 * Global 적용 스타일
 */
const global = css`
	html {
		font-size: 10px;
		scroll-behavior: smooth;
		/* 모바일 폰트 사이즈 자동 조절 문제 방지 */
		-webkit-text-size-adjust: none; /*Chrome, Safari, newer versions of Opera*/
		-moz-text-size-adjust: none; /*Firefox*/
		-ms-text-size-adjust: none; /*Ie*/
		-o-text-size-adjust: none; /*old versions of Opera*/
	}

	@media (prefers-reduced-motion: reduce) {
		html {
			scroll-behavior: auto;
		}
	}

	body {
		font-family: Pretendard, -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
		font-size: 1.6rem;
		line-height: 1.55;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-rendering: optimizeLegibility;
		color: #212529;
	}

	::selection {
		background: rgba(18, 83, 158, 0.18);
		color: inherit;
	}

	:focus-visible {
		outline: 2px solid #12539e;
		outline-offset: 2px;
	}

	.wrapper {
		display: flex;
		min-height: 100vh;
		flex-direction: column;
	}
	.hidden {
		height: 100%;
		min-height: 100%;
		overflow: hidden;
		touch-action: none;
	}
	main {
		display: flex;
		flex-direction: column;
		flex: 1;
		min-width: 0;
	}
	footer {
		flex-shrink: 0;
	}
	img {
		max-width: 100%;
		height: auto;
	}

	/* 네이티브 폼·버튼 기본 곡률 (컴포넌트에서 circle/pill 등으로 덮어씀) */
	input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='hidden']):not([type='file']),
	textarea,
	select {
		border-radius: ${borderRadius.control};
	}
	button {
		border-radius: ${borderRadius.control};
	}
`;

export default global;
